export const Logo = ({ className = "h-9 w-9", light = false }) => {
  const fill = light ? "#FDFCF7" : "#1F3D36";
  const ink = light ? "#1F3D36" : "#FDFCF7";
  return (
    <svg viewBox="0 0 24 24" className={className} aria-label="SentinelGuide logo" role="img">
      <path d="M12 1.5 20.5 4.6V11c0 5.6-3.6 9.9-8.5 11.5C7.1 20.9 3.5 16.6 3.5 11V4.6Z" fill={fill} />
      <path d="M12 4.3l.6 1.4 1.4.6-1.4.6-.6 1.4-.6-1.4-1.4-.6 1.4-.6Z" fill="#C85A32" />
      <g stroke={ink} strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <path d="M12 8.6v8.2M10 16.9h4M7.6 10.1h8.8" />
        <path d="M7.6 10.1 6.2 13.2M7.6 10.1 9 13.2M16.4 10.1l-1.4 3.1M16.4 10.1l1.4 3.1" />
        <path d="M5.9 13.2h3.4a1.7 1.7 0 0 1-3.4 0ZM14.7 13.2h3.4a1.7 1.7 0 0 1-3.4 0Z" />
      </g>
    </svg>
  );
};
